import { cloneDeep } from "@swiggy-private/js-utils";

import type { IToingPriceComparisonBEData } from "../components/price-comparison-halfcard/types";

const INSTRUCTION_LOTTIE_LAYER_NAMES = {
    FREE_CASH_MULTIPLIER: "Multiplier",
} as const;

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const isTextLayer = (layer: any) => layer.ty === 5;

export function updateInstructionLottieData(
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    lottieData: any,
    instructionsData: IToingPriceComparisonBEData["instructions_data"],
) {
    const updatedLottie = cloneDeep(lottieData);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    updatedLottie.layers?.forEach((layer: any) => {
        if (!isTextLayer(layer)) return;

        const layerName = layer.nm;
        const textValue = (() => {
            switch (layerName) {
                case INSTRUCTION_LOTTIE_LAYER_NAMES.FREE_CASH_MULTIPLIER:
                    return instructionsData?.free_cash_multiplier;
                default:
                    return undefined;
            }
        })();

        if (textValue != null && layer.t?.d?.k?.[0]?.s?.t != null) {
            layer.t.d.k[0].s.t = textValue;
        }
    });

    return updatedLottie;
}
